var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1665 39.3372C34.6085 39.3372 35.0324 39.1616 35.345 38.8491C35.6576 38.5365 35.8332 38.1126 35.8332 37.6706V10.9589C35.8323 8.31837 34.7827 5.78628 32.9153 3.91946C31.0478 2.05263 28.5154 1.00391 25.8748 1.00391H5.83317C5.39114 1.00391 4.96722 1.1795 4.65466 1.49206C4.3421 1.80462 4.1665 2.22855 4.1665 2.67057V37.6706C4.1665 38.1126 4.3421 38.5365 4.65466 38.8491C4.96722 39.1616 5.39114 39.3372 5.83317 39.3372H34.1665Z",
    stroke: "#2872B7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 1.13574V7.67074C27.5 8.11277 27.6756 8.5367 27.9882 8.84926C28.3007 9.16182 28.7246 9.33741 29.1667 9.33741H35.7",
    stroke: "#2872B7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1313 25.1704C14.1313 25.8335 13.868 26.4693 13.3991 26.9382C12.9303 27.407 12.2944 27.6704 11.6313 27.6704H9.13135V22.6704H11.6313C12.2944 22.6704 12.9303 22.9338 13.3991 23.4026C13.868 23.8715 14.1313 24.5074 14.1313 25.1704Z",
    stroke: "#2872B7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13135 32.6689V27.6689",
    stroke: "#2872B7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4648 22.6704C18.7909 22.6704 20.0627 23.1972 21.0004 24.1349C21.9381 25.0726 22.4648 26.3443 22.4648 27.6704C22.4648 28.9965 21.9381 30.2683 21.0004 31.2059C20.0627 32.1436 18.7909 32.6704 17.4648 32.6704V22.6704Z",
    stroke: "#2872B7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7983 32.6704V24.3371C25.7983 23.895 25.9739 23.4711 26.2865 23.1586C26.5991 22.846 27.023 22.6704 27.465 22.6704H30.7983",
    stroke: "#2872B7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7983 27.6689H29.1317",
    stroke: "#2872B7",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.17041)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c0ce9292f96e711be5b8852cfe7e1d7c.svg";
export { ForwardRef as ReactComponent };